<template lang="pug">
    el-upload.uploader(
        :multiple='false'
        :show-file-list="false"
        drag
        action="none"
        :accept="accept"
        :on-preview='onFilePreview'
        :before-upload='onBeforeUpload'
        :http-request='handleFileUpload'
        :on-success='onUploadSuccess'
        :style="uploaderStyle"
    )

      .file-placeholder(v-if='!fileUrl')
        slot(name='placeholder')

      .file(v-if="fileUrl")
        icon.scorm-icon(name='file-archive' color='#1D8CE0' :scale='3')
        a(:href='fileUrl' target='_blank') {{ fileUrl || path }}

      .overlay
        i.upload-icon.el-icon-upload2
        .desc
          template(v-if="fileUrl")
            a(:href='fileUrl' target='_blank') {{ path }}
          template(v-else) Drop file here or click to upload
        el-button(v-if="fileUrl" @click.stop='onClear') Clear

      el-progress.progress-bar(v-if='uploadPercentage' :percentage="uploadPercentage")

</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    initialUrl: {
      type: String
    },
    bucketKey: {
      type: String,
      required: true
    },
    accept: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      uploadPercentage: null,
      fullUrl: null,
      path: null,
      cleared: false
    };
  },
  computed: {
    fileUrl() {
      if (this.cleared) {
        return null;
      }

      return this.fullUrl || this.initialUrl || null;
    },
    uploaderStyle() {
      return {};
    }
  },
  methods: {
    onBeforeUpload() {
      this.$emit("upload-started");
    },
    handleFileUpload({ file }) {
      return this.$store.dispatch("upload/uploadFile", {
        file,
        bucketKey: this.bucketKey,
        options: { onProgress: this.onUploadProgress }
      });
    },
    onUploadProgress(percentage) {
      this.uploadPercentage = percentage;
    },
    onFilePreview({ url }) {
      window.open(url);
    },
    onUploadSuccess({ fullUrl, path }) {
      this.fullUrl = fullUrl;
      this.path = path;
      this.cleared = false;
      this.uploadPercentage = 0;
      this.$emit("upload-success");
      this.$emit("input", path);
    },
    onClear() {
      this.cleared = true;
      this.fullUrl = null;
      this.$emit("input", null);
      this.uploadPercentage = 0;
    }
  }
};
</script>

<style scoped lang="scss">
.progress-bar {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
}

.uploader {
  background-position: center center;
  background-size: cover;
  width: 100%;
  border-radius: 2px;
  background-color: white;
  border: 1px solid #bfcbd9;

  :global(.el-upload) {
    display: block;
  }

  :global(.el-upload-dragger) {
    width: 100%;
    border: 0;
    background: transparent;
    position: relative;
    border-radius: 2px;
  }

  &.placeholder {
    background-size: contain;
  }
}

.upload-icon {
  display: block;
  font-size: 40px;
  color: white;
}

.overlay {
  opacity: 0;
  transition: opacity 250ms ease-in-out;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 2px;

  &:hover {
    opacity: 1;
  }
}

.desc {
  color: white;
  margin-top: 10px;
}

.file {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.file-placeholder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
